// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    DispatchBeginLoadProducts,
    DispatchCompleteLoadProducts,
    DispatchLoadProducts,
    DispatchSetFilterQuery,
    DispatchSetParameter,
    DispatchUpdateIdByPath,
    GetUnfilteredProducts,
    HandleSortOrderDefault,
    ParseQueryParameter,
    PopulateApiParameter,
    PrepageProductRecs,
    RemoveNotAvailableAttributeValues,
    RequestCatalogPageFromApi,
    ResetSortTypeIfNeeded,
    SendTracking,
    SetExpandTokens,
    SetIsFiltered,
    SetUpProductInfos,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

export const chain = [
    DispatchBeginLoadProducts,
    RequestCatalogPageFromApi,
    ParseQueryParameter,
    SetIsFiltered,
    SetExpandTokens,
    PopulateApiParameter,
    HandleSortOrderDefault,
    DispatchSetParameter,
    DispatchLoadProducts,
    ResetSortTypeIfNeeded,
    RemoveNotAvailableAttributeValues,
    GetUnfilteredProducts,
    SetUpProductInfos,
    DispatchUpdateIdByPath,
    DispatchCompleteLoadProducts,
    DispatchSetFilterQuery,
    SendTracking,
    PrepageProductRecs,
];

const displayProductsWithoutRealtime = createHandlerChainRunner(chain, "DisplayProductsWithoutRealtime");
export default displayProductsWithoutRealtime;
